import Box from "@/components/Box";
import { theme } from "@/core/theme";
import Center from "@/tpo/Center";
import ChevronComponent from "@/tpo/Chevron";
import Stack from "@/tpo/Stack";
import ButtonV2 from "@/v2/Buttons";

const defaultParagraphs = [
  {
    text: "By updating these details, you are confirming that they still belong to the same patient.",
    fontFamily: "gilroyRegular",
    fontSize: [14, 14, 24]
  },
  {
    text: "If these details relate to a different patient, please create a new patient record. Changing patient details may invalidate results already linked to this account.",
    fontFamily: "gilroyMedium",
    fontSize: [14, 14, 16]
  }
];

export const customerProfileSaveConfirmationContent = {
  title: "Important:",
  paragraphs: [
    {
      text: "Please ensure that any information you update relates to your own personal details and not those of another person.",
      fontFamily: "gilroyRegular",
      fontSize: [14, 14, 24]
    }
  ]
};

export const wardProfileSaveConfirmationContent = {
  title: "Important:",
  paragraphs: [
    {
      text: "Please check that any information you update is right for this ward and not those of another person.",
      fontFamily: "gilroyRegular",
      fontSize: [14, 14, 24]
    }
  ]
};

export default function PatientDetailsSaveConfirmation({
  title = "Patient records should be unique.",
  paragraphs = defaultParagraphs,
  onCancel,
  onSave,
  loading,
  cancelButtonProps,
  saveButtonProps,
  "data-component-name": dataComponentName = "PatientDetailsSaveConfirmation"
}) {
  return (
    <Stack
      gap={[20, 20, 40]}
      mx="auto"
      maxWidth={720}
      width="100%"
      pt={theme.spacing.panelBox.pt}
      pb={theme.spacing.panelBox.pb}
      data-component-name={dataComponentName}
    >
      <Stack gap={[20, 20, 28]} textAlign="center">
        <Box fontFamily="gilroyBold" fontSize={[28, 28, 44]} lineHeight="130%">
          {title}
        </Box>
        {paragraphs.map((paragraph, index) => (
          <Box
            key={index}
            fontFamily={paragraph.fontFamily}
            fontSize={paragraph.fontSize}
            lineHeight={["150%", "150%", "28px"]}
          >
            {paragraph.text}
          </Box>
        ))}
      </Stack>
      <Center gap={20} flexWrap="wrap">
        <ButtonV2
          type="button"
          color="red"
          rightIcon={<ChevronComponent />}
          onClick={onCancel}
          size={["sm", "sm", "md"]}
          disabled={loading}
          {...cancelButtonProps}
        >
          Cancel
        </ButtonV2>
        <ButtonV2
          type="button"
          color="green"
          rightIcon={<ChevronComponent />}
          onClick={onSave}
          size={["sm", "sm", "md"]}
          disabled={loading}
          {...saveButtonProps}
        >
          save
        </ButtonV2>
      </Center>
    </Stack>
  );
}
